// extracted by mini-css-extract-plugin
module.exports = {"container":"AbonnementModalContent_container__1T6EA"};